import axiosInstance from '@/utils/httpUtil'
import { setting } from '@/setting'

const adminBaseUrl = setting.adminBaseUrl

export const coursewareApi = {
    createCourseware: ({memberId, coursewareFile}) => {
        const formData = new FormData();
        // 假设 coursewareFile 是一个 File 或 Blob 对象
        formData.append('coursewareFile', coursewareFile);
        return axiosInstance.post(
            `${adminBaseUrl}/coursewares/${memberId}`,
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          )
    },

    deleteCourseware: (id) => {
        return axiosInstance.delete(`${adminBaseUrl}/coursewares/${id}`);
    }
}